/* FLG MAP v6. Design rationale lives in assets/flg-map.css and
   assets/flg-map-phone.css. This header carries only the rules
   that will bite whoever edits this file.

   1. sizeUp DOES NOT SUBTRACT THE STICKY HEADER. docTop is the
      split's distance from the top of the DOCUMENT and already
      includes the call bar, the site header and the filter bar.
      v4 subtracted the header again on top of that and threw
      away 150px: 779px of map in a 1229px viewport instead of
      905. Do not reintroduce a stickyHeader term. The 45 percent
      cap protects a page where the map sits far down.

   2. GRID IGNORES THE MAP BOUNDS. In grid the map is
      display:none and its bounds are stale. Unguarded, a visitor
      who zoomed into Florida then hit Grid would see six of nine
      parcels on a page titled All listings. inView returns the
      list untouched in grid.

   3. SPLIT DOES NOT EXIST ON A PHONE. A draggable map above a
      scrolling list traps the page scroll.

   4. LEAVING GRID REMEASURES. A display:none map has a zero
      sized container, so invalidateSize comes first.

   5. THE COUNT, THE EXPAND CONTROL AND THE FILTERS COLLAPSE ARE
      BUILT HERE, NOT IN THE LIQUID. They enhance a map that does
      not work without JavaScript anyway, and building them here
      is why the whole UI pass shipped as asset files. Keep it
      that way: it is a 1KB tweak instead of an 18KB rewrite.

   FRAMING RULES THAT MUST NOT COME BACK AS BUGS:
     a. sizeUp calls invalidateSize THEN refits, guarded by
        userMoved so it never yanks the map from under someone
        who has panned.
     b. zoomSnap 0.25. Whole steps made a fit wanting 5.6 land on
        5 and fill half the pane.
     c. Pixel padding, not bounds.pad().
     d. Esri World Imagery is {z}/{y}/{x}. y before x.

   OPENING VIEW is the region holding the most parcels, not all
   of them. Fitting Illinois and Florida in one frame zooms out
   so far that every parcel falls inside the cluster radius, so
   you get anonymous count bubbles and no prices on a map that is
   mostly ocean. */
(function(){
  var root = document.querySelector('.fmap');
  if(!root || typeof L === 'undefined' || !window.FLG_MAP) return;

  var CFG = window.FLG_MAP, ITEMS = CFG.items || [], VIEW = CFG.viewLabel || 'View details';
  var map, cluster, markers = {}, allPts = [], booted = false;
  var lastFit = null, fitting = false, userMoved = false;
  var FKEYS = ['fm-county','fm-price','fm-acres','fm-access','fm-status'];
  var countEl, expandEl, filtEl;

  var $  = function(s){ return root.querySelector(s); };
  var $$ = function(s){ return Array.prototype.slice.call(root.querySelectorAll(s)); };
  var isPhone = function(){ return window.matchMedia('(max-width:750px)').matches; };
  var mode = function(){ return root.getAttribute('data-mode') || 'split'; };

  /* ---------- controls the liquid does not ship. Rule 5. ---------- */
  (function buildUI(){
    var barin = $('.barin'), modes = $('.modes'), live = $('.live'), clr = $('.clr');
    if(!barin) return;

    if(modes && modes.nextSibling){
      var rule = document.createElement('span');
      rule.className = 'rule';
      barin.insertBefore(rule, modes.nextSibling);
    }

    /* right hand group first, because moving the sort out of the
       bar is what leaves exactly the five filters behind. */
    var right = document.createElement('div');
    right.className = 'right';
    countEl = document.createElement('p');
    countEl.className = 'count';
    right.appendChild(countEl);
    var sort = document.getElementById('fm-sort');
    if(sort && sort.parentNode) right.appendChild(sort.parentNode);
    if(live) right.appendChild(live);
    barin.appendChild(right);
    if(clr) barin.insertBefore(clr, right);

    /* now wrap what is left. display:contents keeps the desktop
       row identical; the phone sheet turns the wrapper on. */
    var flds = Array.prototype.slice.call(barin.children).filter(function(el){
      return el.classList && el.classList.contains('fld');
    });
    if(flds.length){
      var box = document.createElement('div');
      box.className = 'filters';
      flds[0].parentNode.insertBefore(box, flds[0]);
      flds.forEach(function(f){ box.appendChild(f); });

      filtEl = document.createElement('button');
      filtEl.type = 'button';
      filtEl.className = 'filt';
      filtEl.setAttribute('aria-expanded', 'false');
      box.parentNode.insertBefore(filtEl, box);
      filtEl.addEventListener('click', function(){
        var open = root.classList.toggle('filters-open');
        filtEl.classList.toggle('on', open);
        filtEl.setAttribute('aria-expanded', open ? 'true' : 'false');
        setTimeout(sizeUp, 40);
      });
    }

    var wrap = $('.mapwrap');
    if(wrap){
      expandEl = document.createElement('button');
      expandEl.type = 'button';
      expandEl.className = 'expand';
      expandEl.textContent = CFG.expandLabel || 'Expand';
      wrap.appendChild(expandEl);
    }
  })();

  function bottomBar(){
    var bars = document.querySelectorAll('.dock, .flg-dock, [class*="mobile-dock"]');
    var tallest = 0;
    for(var i = 0; i < bars.length; i++){
      var el = bars[i], cs = getComputedStyle(el);
      if(cs.position !== 'fixed' || cs.display === 'none' || cs.visibility === 'hidden') continue;
      var b = el.getBoundingClientRect();
      if(b.height < 1) continue;
      if(b.bottom >= window.innerHeight - 2 && b.height > tallest) tallest = b.height;
    }
    return Math.round(tallest);
  }

  function region(it){
    if(!it.cty) return 'other';
    var bits = String(it.cty).split(',');
    return bits[bits.length - 1].trim() || 'other';
  }

  function biggestRegion(list){
    var by = {};
    list.forEach(function(it){
      if(it.lat === null) return;
      var r = region(it);
      (by[r] = by[r] || []).push([it.lat, it.lng]);
    });
    var best = null;
    Object.keys(by).forEach(function(k){ if(!best || by[k].length > by[best].length) best = k; });
    return best ? by[best] : [];
  }

  function fit(pts){
    if(!map || !pts || !pts.length) return;
    lastFit = pts;
    fitting = true;
    map.fitBounds(L.latLngBounds(pts), {
      animate: false, padding: [58, 58], maxZoom: pts.length === 1 ? 12 : 15
    });
    setTimeout(function(){ fitting = false; }, 0);
  }

  /* Rule 1. Read the header before changing a single term. */
  function sizeUp(){
    var split = $('.split');
    if(!split) return;
    if(mode() !== 'grid' && !root.classList.contains('is-full')){
      var docTop = split.getBoundingClientRect().top + window.scrollY;
      var cap = window.innerHeight * 0.45;
      var h = window.innerHeight - Math.min(docTop, cap) - bottomBar();
      root.style.setProperty('--fm-h', Math.max(420, Math.round(h)) + 'px');
    }
    if(map){
      map.invalidateSize();
      if(!userMoved && lastFit) fit(lastFit);
    }
  }

  function pill(n){
    if(!n && n !== 0) return CFG.noPrice || 'Ask';
    if(n >= 1000){ var k = n / 1000; return '$' + (k >= 100 ? Math.round(k) : Math.round(k * 10) / 10) + 'k'; }
    return '$' + n;
  }

  function band(v, kind){
    if(v === null) return 'na';
    if(kind === 'price'){ return v < 10000 ? 'a' : v < 20000 ? 'b' : v < 35000 ? 'c' : 'd'; }
    return v < 0.25 ? 'a' : v < 0.5 ? 'b' : v < 1 ? 'c' : 'd';
  }
  function val(id){ var e = document.getElementById(id); return e ? e.value : ''; }

  function matching(){
    var f = { county: val('fm-county'), price: val('fm-price'), acres: val('fm-acres'),
              access: val('fm-access'), status: val('fm-status') };
    var out = ITEMS.filter(function(it){
      if(f.county && it.cty !== f.county) return false;
      if(f.access && it.acc !== f.access) return false;
      if(f.status && it.st  !== f.status) return false;
      if(f.price  && band(it.pn, 'price') !== f.price) return false;
      if(f.acres  && band(it.ac, 'acres') !== f.acres) return false;
      return true;
    });
    var s = val('fm-sort');
    if(s === 'plow')  out.sort(function(a,b){ return (a.pn===null)-(b.pn===null) || a.pn-b.pn; });
    if(s === 'phigh') out.sort(function(a,b){ return (a.pn===null)-(b.pn===null) || b.pn-a.pn; });
    if(s === 'big')   out.sort(function(a,b){ return (a.ac===null)-(b.ac===null) || b.ac-a.ac; });
    if(s === 'new')   out.sort(function(a,b){ return b.d - a.d; });
    return out;
  }

  /* Rule 2. */
  function inView(list){
    if(mode() === 'grid') return list;
    var live = $('#fm-live');
    if(!map || !live || !live.checked || !booted) return list;
    var b = map.getBounds();
    return list.filter(function(it){ return it.lat === null ? false : b.contains([it.lat, it.lng]); });
  }

  function cardHTML(it){
    var img = it.img ? '<img src="' + it.img + '" alt="" loading="lazy" width="320" height="240">' : '';
    var cls = it.st === 'hold' ? ' is-hold' : (it.st === 'closed' ? ' is-closed' : '');
    var tag = it.st === 'hold' ? CFG.tagHold : (it.st === 'closed' ? CFG.tagClosed : CFG.tagOpen);
    var facts = '';
    if(it.acf) facts += '<span class="mi">' + it.acf + '</span>';
    if(it.acc) facts += '<span class="mi">' + it.acc + '</span>';
    var price = it.pf ? '<span class="amt">' + it.pf + '</span>'
                      : '<span class="none">' + (CFG.noPrice || 'Price on request') + '</span>';
    return '<a class="card" href="' + it.u + '" data-id="' + it.id + '">' +
      '<span class="shot">' + img + '<span class="tag' + cls + '">' + tag + '</span></span>' +
      '<span class="txt">' +
        (it.ctys ? '<span class="cty">' + it.ctys + '</span>' : '') +
        '<h3>' + it.t + '</h3>' +
        (facts ? '<span class="row">' + facts + '</span>' : '') +
        '<span class="foot">' + price + '<span class="go">' + VIEW + '</span></span>' +
      '</span></a>';
  }

  function paintRail(){
    var all = matching();
    var shown = inView(all);
    var word = shown.length === 1 ? CFG.wordOne : CFG.wordMany;

    /* the count is the most important number on a search UI, so
       it is in the bar as well as the rail. The rail header is
       invisible in map view and below the fold in grid. */
    if(countEl) countEl.innerHTML = shown.length + '<small>' + word + '</small>';

    var cnt = $('.railhd .cnt');
    if(cnt) cnt.innerHTML = '<b>' + shown.length + '</b> ' + word;
    var wrap = $('.cards');
    if(wrap) wrap.innerHTML = shown.map(cardHTML).join('');
    var end = $('.railend');
    if(end){
      var live = $('#fm-live');
      var moving = mode() !== 'grid' && live && live.checked;
      end.textContent = shown.length ? (moving ? CFG.moveNote : CFG.endNote)
                                     : (moving ? CFG.emptyView : CFG.emptyText);
    }
    $$('.card').forEach(function(c){
      c.addEventListener('mouseenter', function(){ if(!isPhone() && mode() !== 'grid') focus(c.dataset.id, false); });
    });
    var none = $('.empty');
    if(none) none.textContent = all.length ? '' : CFG.emptyText;
  }

  function paintMap(refit){
    var list = matching();
    if(cluster) cluster.clearLayers();
    markers = {};
    allPts = [];
    var batch = [];

    list.forEach(function(it){
      if(it.lat === null || it.lng === null) return;
      var cls = 'pin' + (it.st === 'hold' ? ' is-hold' : (it.st === 'closed' ? ' is-closed' : ''));
      var m = L.marker([it.lat, it.lng], {
        icon: L.divIcon({ className: cls, html: '<b>' + pill(it.pn) + '</b>', iconSize: [0,0] }),
        title: it.t, riseOnHover: true
      });
      m.bindPopup(cardHTML(it), { closeButton:true, offset:[0,-12], minWidth:252, maxWidth:252, autoPanPadding:[30,30] });
      m.on('click', function(){ focus(it.id, true); });
      batch.push(m);
      markers[it.id] = m;
      allPts.push([it.lat, it.lng]);
    });

    if(cluster && batch.length) cluster.addLayers(batch);

    if(refit === 'all') fit(allPts);
    else if(refit === 'open') fit(CFG.openOn === 'all' ? allPts : biggestRegion(list));
  }

  function redraw(refit){
    if(refit) userMoved = false;
    paintMap(refit || 'all');
    paintRail();
    flagSet();
  }

  function focus(id, fromMap){
    $$('.card').forEach(function(c){ c.classList.toggle('lit', c.dataset.id === String(id)); });
    Object.keys(markers).forEach(function(k){
      var el = markers[k]._icon;
      if(!el) return;
      el.classList.toggle('on', k === String(id));
      el.classList.toggle('lit', k === String(id));
    });
    if(fromMap){
      var m = markers[id];
      if(m && m._icon) m._icon.classList.add('seen');
      if(!isPhone() && mode() === 'split'){
        var card = root.querySelector('.card[data-id="' + id + '"]');
        var rail = $('.rail');
        if(card && rail) rail.scrollTo({ top: card.offsetTop - 70, behavior: 'smooth' });
      }
    }
  }

  /* Clear and the phone Filters button both say how many filters
     are on, so the bar tells you how filtered you are without
     you reading five dropdowns. */
  function flagSet(){
    var n = 0;
    FKEYS.forEach(function(id){
      var e = document.getElementById(id);
      if(!e) return;
      var on = !!e.value;
      e.classList.toggle('set', on);
      if(on) n++;
    });
    var c = $('.clr');
    if(c){
      c.hidden = n === 0;
      if(n) c.textContent = (CFG.clearLabel || 'Clear') + ' ' + n;
    }
    if(filtEl){
      filtEl.innerHTML = (CFG.filtersLabel || 'Filters') + (n ? ' <b>' + n + '</b>' : '');
    }
  }

  function setMode(m){
    if(m === 'split' && isPhone()) m = 'map';
    root.setAttribute('data-mode', m);
    $$('.modes button').forEach(function(b){ b.classList.toggle('on', b.dataset.mode === m); });
    if(m === 'grid'){ paintRail(); return; }
    setTimeout(function(){ sizeUp(); paintRail(); }, 30);
  }

  function setFull(on){
    root.classList.toggle('is-full', on);
    document.documentElement.style.overflow = on ? 'hidden' : '';
    if(expandEl) expandEl.textContent = on ? (CFG.collapseLabel || 'Close') : (CFG.expandLabel || 'Expand');
    setTimeout(function(){ if(map) map.invalidateSize(); sizeUp(); }, 60);
  }

  var BASE = {
    satellite: { url:'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
                 opts:{ maxZoom:19, attribution:'Imagery: Esri, Maxar, Earthstar Geographics' } },
    street:    { url:'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
                 opts:{ maxZoom:19, attribution:'&copy; OpenStreetMap contributors' } },
    terrain:   { url:'https://{s}.tile.opentopomap.org/{z}/{x}/{y}.png',
                 opts:{ maxZoom:17, attribution:'Map data: &copy; OpenStreetMap, SRTM. Style: &copy; OpenTopoMap' } }
  };
  var tiles = null;
  function base(name){
    if(!BASE[name]) name = 'satellite';
    if(tiles) map.removeLayer(tiles);
    tiles = L.tileLayer(BASE[name].url, BASE[name].opts).addTo(map);
    tiles.bringToBack();
    $$('.basemaps button').forEach(function(b){ b.classList.toggle('on', b.dataset.base === name); });
  }

  function boot(){
    var el = $('.map');
    if(!el) return;

    map = L.map(el, { scrollWheelZoom:false, zoomControl:true, zoomSnap:0.25, zoomDelta:0.5, minZoom:3 })
           .setView([28.6, -82.4], 6);
    base(CFG.base || 'satellite');

    cluster = (typeof L.markerClusterGroup === 'function')
      ? L.markerClusterGroup({
          showCoverageOnHover:false, spiderfyOnMaxZoom:true, maxClusterRadius:30,
          iconCreateFunction: function(c){
            var n = c.getChildCount();
            return L.divIcon({ className:'clu' + (n > 9 ? ' big' : ''), html:'<i>' + n + '</i>', iconSize:[0,0] });
          }
        })
      : L.layerGroup();
    map.addLayer(cluster);

    el.addEventListener('wheel', function(e){
      if(e.ctrlKey || e.metaKey){ e.preventDefault(); map.scrollWheelZoom.enable(); }
      else { map.scrollWheelZoom.disable(); }
    }, { passive:false });

    map.on('dragstart', function(){ userMoved = true; });
    map.on('zoomstart', function(){ if(!fitting) userMoved = true; });

    $$('.basemaps button').forEach(function(b){
      b.addEventListener('click', function(){ base(b.dataset.base); });
    });
    FKEYS.concat(['fm-sort']).forEach(function(id){
      var s = document.getElementById(id);
      if(s) s.addEventListener('change', function(){ redraw('all'); });
    });
    var clr = $('.clr');
    if(clr) clr.addEventListener('click', function(){
      FKEYS.concat(['fm-sort']).forEach(function(id){
        var s = document.getElementById(id); if(s) s.value = '';
      });
      redraw('open');
    });
    var live = $('#fm-live');
    if(live) live.addEventListener('change', paintRail);
    var refit = $('.refit');
    if(refit) refit.addEventListener('click', function(){ userMoved = false; fit(allPts); });

    if(expandEl) expandEl.addEventListener('click', function(){ setFull(!root.classList.contains('is-full')); });
    document.addEventListener('keydown', function(e){
      if(e.key !== 'Escape') return;
      if(root.classList.contains('is-full')) setFull(false);
      else if(root.classList.contains('filters-open') && filtEl) filtEl.click();
    });

    $$('.modes button').forEach(function(b){
      b.addEventListener('click', function(){ setMode(b.dataset.mode); });
    });

    map.on('moveend zoomend', function(){ if(booted && mode() !== 'grid') paintRail(); });

    setMode(root.getAttribute('data-mode') || 'split');
    sizeUp();
    redraw('open');
    booted = true;
    paintRail();

    [140, 420, 1000].forEach(function(ms){ setTimeout(function(){ sizeUp(); }, ms); });
    window.addEventListener('load', sizeUp);
    if(document.fonts && document.fonts.ready){ document.fonts.ready.then(sizeUp); }

    var t;
    window.addEventListener('resize', function(){
      clearTimeout(t);
      t = setTimeout(function(){
        if(mode() === 'split' && isPhone()) setMode('map');
        else sizeUp();
      }, 120);
    });
    window.addEventListener('orientationchange', function(){
      setTimeout(function(){
        if(mode() === 'split' && isPhone()) setMode('map');
        else sizeUp();
      }, 320);
    });
    if(window.ResizeObserver){
      new ResizeObserver(function(){ if(map && mode() !== 'grid') map.invalidateSize(); }).observe($('.mapwrap'));
    }
  }

  function ready(){
    if(typeof L.markerClusterGroup === 'function' || ready.tries++ > 40) return boot();
    setTimeout(ready, 50);
  }
  ready.tries = 0;

  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', ready); }
  else { ready(); }
})();
